import React from 'react';

const EducationForm = ({ data, onChange }) => {
  const addEducation = () => {
    onChange([...data, {
      degree: '',
      school: '',
      location: '',
      graduationDate: '',
      gpa: '',
      honors: '',
      link: ''
    }]);
  };

  const removeEducation = (index) => {
    const newData = data.filter((_, i) => i !== index);
    onChange(newData);
  };

  const updateEducation = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    onChange(newData);
  };

  return (
    <div className="form-section">
      <h2 className="section-title">Education</h2>
      <p className="section-description">
        List your educational background, starting with the most recent degree.
        Include relevant coursework, honors, or achievements.
      </p>

      {data.map((edu, index) => (
        <div key={index} className="entry-card">
          <div className="entry-header">
            <span className="entry-number">Education {index + 1}</span>
            {data.length > 1 && (
              <button
                className="remove-button"
                onClick={() => removeEducation(index)}
              >
                Remove
              </button>
            )}
          </div>

          <div className="form-group">
            <label className="form-label required">Degree</label>
            <input
              type="text"
              className="form-input"
              value={edu.degree}
              onChange={(e) => updateEducation(index, 'degree', e.target.value)}
              placeholder="Bachelor of Science in Computer Science"
            />
          </div>

          <div className="form-group">
            <label className="form-label required">School/University</label>
            <input
              type="text"
              className="form-input"
              value={edu.school}
              onChange={(e) => updateEducation(index, 'school', e.target.value)}
              placeholder="Massachusetts Institute of Technology"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Location</label>
              <input
                type="text"
                className="form-input"
                value={edu.location}
                onChange={(e) => updateEducation(index, 'location', e.target.value)}
                placeholder="Cambridge, MA"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Graduation Date</label>
              <input
                type="text"
                className="form-input"
                value={edu.graduationDate}
                onChange={(e) => updateEducation(index, 'graduationDate', e.target.value)}
                placeholder="May 2020"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">GPA (Optional)</label>
            <input
              type="text"
              className="form-input"
              value={edu.gpa}
              onChange={(e) => updateEducation(index, 'gpa', e.target.value)}
              placeholder="3.8/4.0"
            />
            <p className="form-hint">Only include if 3.5 or higher</p>
          </div>

          <div className="form-group">
            <label className="form-label">Honors & Achievements</label>
            <textarea
              className="form-textarea"
              value={edu.honors}
              onChange={(e) => updateEducation(index, 'honors', e.target.value)}
              placeholder="Dean's List, Magna Cum Laude, Relevant Coursework: Data Structures, Algorithms, Machine Learning"
              rows="3"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Education Certification Link (Optional)</label>
            <input
              type="url"
              className="form-input"
              value={edu.link}
              onChange={(e) => updateEducation(index, 'link', e.target.value)}
              placeholder="https://university.edu/verify/degree123"
            />
            <p className="form-hint">
              Add a link to degree verification or online certificate (optional)
            </p>
          </div>
        </div>
      ))}

      <button className="add-button" onClick={addEducation}>
        + Add Another Degree
      </button>
    </div>
  );
};

export default EducationForm;
